import React from 'react';
import TicketList from './ticket-list/TicketList';
import PerformanceInfo from './PerformanceInfo';
import { Line, RedLine } from '../utils/Symbols'

export default function(props) {
    return (
        <React.Fragment>
            
            <RedLine />
            <div>
                Информация о покупателе:
            </div>
            <div>
                Имя: {props.order.customer.name}
            </div>
            <div>
                E-mail: {props.order.customer.email}
            </div>

            <Line />
            <PerformanceInfo performance={props.order.performance} />
            
            <Line />
            <TicketList tickets={props.order.tickets} />

        </React.Fragment>
    );
}
